import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList } from "recharts";

const renderQuarterTick = (tickProps) => {
  const { x, y, payload } = tickProps;

  if (true) {
    return <text x={x} y={y - 4} fontSize={11} textAnchor="middle">{payload.value}</text>;
  }
};


const CustomizedLabel = (props) => {
  const { x, y, value,width } = props;
  return (
    <g>
    <rect
          x={(x + props.width / 2)-23}
          y={y - 26}
          width="45px"
          height="20px"
          fill="#908079"
        />
      <text
        x={x + width / 2}
        y={y}
        dy={-12}
        fill='#fff'
        fontSize={12}
        fontWeight={600}
        textAnchor="middle"
      >
        {value}%
      </text>
    </g>
  );
};

const CustomizedDodLabel = (props) => {
  const { x, y, value,width } = props;
  return (
    <g>
      <text
        x={x + width / 2}
        y={y}
        dy={-5}
        fill={'rgb(252, 163, 17)'}
        fontSize={12}
        fontWeight={600}
        textAnchor="middle"
      >
        {value}%
      </text>
    </g>
  );
};

const CustomizedVodLabel = (props) => {
  const { x, y, value,width } = props;
  return (
    <g>
      <text
        x={x + width / 2}
        y={y}
        dy={value === 0 ? -5 : 15}
        fill={'rgb(3, 83, 164)'}
        fontSize={12}
        fontWeight={600}
        textAnchor="middle"
      >
        {value}%
      </text>
    </g>
  );
};

const renderTooltip = (e, payload, data) => {

  if (e?.payload?.length ) {
    let Label = e.label.split('-')
    if (Label.length === 1) {
      return (
        <div className='chart-tooltip'>
          {
            e.payload.map((item, ind) => (
              <span key={ind}>
                {item.name === 'dod1' || item.name === 'vod1' ? (item.name.slice(0, -1)) + "-" + Label[0] : null}{item.value ? ' : ' + item.value + "%" : null}
              </span>
            ))
          }
        </div>
      )
    }
    else if (Label.length === 2) {
      return (
        <div className='chart-tooltip'>
          {
            e.payload.map((item, ind) => (
              <span key={ind}>
                {item.name === 'dod1' || item.name === 'vod1' ? (item.name.slice(0, -1)) + "-" + Label[0] : (item.name.slice(0, -1)) + "-" + Label[1]} : {item.value + "%"}
              </span>
            ))
          }
        </div>
      )
    }
    else if (Label.length === 3) {
      return (
        <div className='chart-tooltip'>
          {
            e.payload.map((item, ind) => (
              <span key={ind}>
                {item.name === 'dod1' || item.name === 'vod1' ? (item.name.slice(0, -1)) + "-" + Label[0] :
                  item.name === 'dod2' || item.name === 'vod2' ? (item.name.slice(0, -1)) + "-" + Label[1] : (item.name.slice(0, -1)) + "-" + Label[2]}
                : {item.value + "%"}
              </span>
            ))
          }
        </div>
      )
    }
    else if (Label.length === 4) {
      return (
        <div className='chart-tooltip'>
          {
            e.payload.map((item, ind) => (
              <span key={ind} >
                {item.name === 'dod1' || item.name === 'vod1' ? (item.name.slice(0, -1)) + "-" + Label[0] :
                  item.name === 'dod2' || item.name === 'vod2' ? (item.name.slice(0, -1)) + "-" + Label[1] :
                    item.name === 'dod3' || item.name === 'vod3' ? (item.name.slice(0, -1)) + "-" + Label[2] : (item.name.slice(0, -1)) + "-" + Label[3]}
                : {item.value + "%"}
              </span>
            ))
          }
        </div>
      )
    }
    else if (Label.length === 5) {
      return (
        <div className='chart-tooltip'>
          {
            e.payload.map((item, ind) => (
              <span key={ind}>
                {item.name === 'dod1' || item.name === 'vod1' ? (item.name.slice(0, -1)) + "-" + Label[0] :
                  item.name === 'dod2' || item.name === 'vod2' ? (item.name.slice(0, -1)) + "-" + Label[1] :
                    item.name === 'dod3' || item.name === 'vod3' ? (item.name.slice(0, -1)) + "-" + Label[2] :
                      item.name === 'dod4' || item.name === 'vod4' ? (item.name.slice(0, -1)) + "-" + Label[3] : (item.name.slice(0, -1)) + "-" + Label[4]}
                : {item.value + "%"}
              </span>
            ))
          }
        </div>
      )
    }
  }
      else{
        return <></>
      }
}

function StackedBarChart(props) {
  return (
    <ResponsiveContainer height={400} width="100%">
      <BarChart
        width={500}
        height={80}
        data={props.data ? props.data : []}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }}
        barCategoryGap={'10%'}
      >
        <XAxis dataKey="year" axisLine={{ stroke: '#e6e6e7' }} style={{ fontSize: "11px" }} tickLine={false} />
        <XAxis dataKey="name" axisLine={false} tickLine={false} interval={0} tick={renderQuarterTick} height={1} scale="band" xAxisId="quarter" />
        <YAxis padding={{ top: 35 }} tickFormatter={tick => { return tick + '%' }} axisLine={{ stroke: '#e6e6e7' }} tickLine={false} />

        <Tooltip content={(e, payload) => renderTooltip(e, payload, props.data)} />

        <Bar dataKey="dod1" stackId="a" stroke='#fca311' strokeWidth={2} fill="#fca311" >
          <LabelList dataKey='dod1' content={CustomizedDodLabel} fontSize={10} position="top" />
        </Bar>
        <Bar dataKey="vod1" stackId="a" strokeWidth={2} stroke='#0353a4' fill="transparent" >
          <LabelList dataKey='vod1' content={CustomizedVodLabel} fontSize={10} position="top" />
          {/* <LabelList dataKey='dod1' content={CustomizedDodLabel} fontSize={10} position="top" /> */}
          <LabelList dataKey='PromotionIntensity1' content={CustomizedLabel} fontSize={10} position="top" />
        </Bar>

        <Bar dataKey="dod2" stackId="b" strokeWidth={2} stroke='#fca311' fill="#fca311" hide={props.yearsLength >= 2 ? false : true} >
          <LabelList dataKey='dod2' content={CustomizedDodLabel} fontSize={10} position="top" />
        </Bar>
        <Bar dataKey="vod2" stackId="b" strokeWidth={2} stroke='#0353a4' fill="transparent" hide={props.yearsLength >= 2 ? false : true} >
          <LabelList dataKey='vod2' content={CustomizedVodLabel} fontSize={10} position="top" />
          {/* <LabelList dataKey='dod2' content={CustomizedDodLabel} fontSize={10} position="top" /> */}
          <LabelList dataKey='PromotionIntensity2' content={CustomizedLabel} fontSize={10} position="top" />
        </Bar>

        {/* <Bar dataKey="dod3" stackId="c" fill="#fca311" hide={props.yearsLength >= 3 ? false : true}  >
          <Cell stroke='#fca311'  strokeWidth={2}/>
          <LabelList dataKey='dod3' content={CustomizedDodLabel} fontSize={10} position="top" />
        </Bar>
        <Bar dataKey="vod3" stackId="c" hide={props.yearsLength >= 3 ? false : true} >
          <Cell stroke='#0353a4' fill="transparent" strokeWidth={2}/>
          <LabelList dataKey='vod3' content={CustomizedVodLabel} fontSize={10} position="top" />
          <LabelList dataKey='dod3' content={CustomizedDodLabel} fontSize={10} position="top" />
          <LabelList dataKey='PromotionIntensity3' content={CustomizedLabel} fontSize={10} position="top" />
        </Bar>

         <Bar dataKey="dod4" stackId="d" fill="#fca311" hide={props.yearsLength >= 4 ? false : true}  />
        <Bar dataKey="vod4" stackId="d" fill="#0353a4" hide={props.yearsLength >= 4 ? false : true} >
          <LabelList dataKey='vod4' content={CustomizedVodLabel} fontSize={10} position="top" />
          <LabelList dataKey='dod4' content={CustomizedDodLabel} fontSize={10} position="top" />
          <LabelList dataKey='PromotionIntensity4' content={CustomizedLabel} fontSize={10} position="top" />
        </Bar>

        <Bar dataKey="dod5" stackId="e" fill="#fca311" hide={props.yearsLength >= 5 ? false : true}  />
        <Bar dataKey="vod5" stackId="e" fill="#0353a4" hide={props.yearsLength >= 5 ? false : true} >
          <LabelList dataKey='vod5' content={CustomizedVodLabel} fontSize={10} position="top" />
          <LabelList dataKey='dod5' content={CustomizedDodLabel} fontSize={10} position="top" />
          <LabelList dataKey='PromotionIntensity5' content={CustomizedLabel} fontSize={10} position="top" />
        </Bar> */}

      </BarChart>
    </ResponsiveContainer>
  );
}

export default StackedBarChart;
